import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(5),
  },
  logo: {
    textAlign: "center",
    paddingRight: "24px"
  }
}));

export default (props) => {
  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <Grid container direction="row">
        <Grid item md={4}>
          <div className={classes.logo}><img src={props.config.eventPanel.imageUrl} alt={props.config.eventPanel.imageAlt} style={{ width: '100%', height: 'auto', maxWidth: "350px" }} /></div>
        </Grid>
        <Grid item md={8}>
          <h1 style={{ marginBottom: '3px' }}>{props.config.eventPanel.title}</h1>
          <h3 style={{ marginBottom: '3px' }}>{props.config.eventPanel.subtitle}</h3>
          <h5 style={{ marginBottom: '12px' }}>{props.config.eventPanel.eventDate}</h5>
          <p>{props.config.eventPanel.description}</p>
          <div className="addthis_inline_share_toolbox_t1se"></div>
        </Grid>
      </Grid>
    </Paper>
  );
}